import * as React from "react";

import { cn } from "@/lib/utils";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea"> & {
    size?: "sm" | "md";
    invalid?: boolean;
  }
>(({ className, size, invalid, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-md border-t border-[#1FB3CC]/15 bg-[#1FB3CC]/15 px-[15px] py-1 text-base font-normal tracking-wide text-white shadow-[inset_0px_1px_2px_0px_#0C0C2633] backdrop-blur-lg transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:font-normal placeholder:text-white/50 focus:bg-[#1FB3CC]/40 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
        size === "sm" && "px-3 text-sm placeholder:text-sm",
        invalid &&
          "!border border-[#E86363] bg-[#E86363]/15 text-white/80 focus:bg-[#E86363]/15",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
